<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Build Works</h1>
        <form @submit.prevent="handleSubmit" v-show="!loading">
          <input type="email" v-model="email" />
          <input type="submit" v-model="submitBtn" />
        </form>

        <div v-show="loading">
          <h2>Please check your email.</h2>
          <p>
            You will recieve an email with a link to log you in, if that doesn't
            happen within a few minutes please try again.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  name: "Landing",
  components: {},
  data: function() {
    return {
      email: "",
      loading: false,
      submitBtn: "Login"
    };
  },
  methods: {
    handleSubmit() {
      var useThis = this;
      var actionCodeSettings = {
        url: "http://localhost:8080/home",
        handleCodeInApp: true
      };

      useThis.submitBtn = "Sending";

      fb.auth
        .sendSignInLinkToEmail(useThis.email, actionCodeSettings)
        .then(function() {
          window.localStorage.setItem("emailForSignIn", useThis.email);
          useThis.loading = true;
          useThis.submitBtn = "Sent";
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
